import { useLovedStoryFeedStore } from "SmartFeed/stores/feed/loved-story-feed-store";
import { useVotedStoryFeedStore } from "SmartFeed/stores/feed/voted-story-feed-store";
import { useCommentedStoryFeedStore } from "SmartFeed/stores/feed/commented-story-feed-store";
import { useExclusiveStoryFeedStore } from "SmartFeed/stores/feed/exclusive-story-feed-store";
import { useFeedGroupBlogPostFeedStore } from "SmartFeed/stores/feed/feed-group-blog-post-feed-store";
import { useEventFeedStore } from "~/smart-feed/stores/feed/event-feed-store";
import { useFanFollowerBeingFollowedFeedStore } from "SmartFeed/stores/feed/fan-follower-being-followed-feed-store";
import { useFanFollowerFollowingFeedStore } from "SmartFeed/stores/feed/fan-follower-following-feed-store";
import { useFollowersFeedStore } from "~/smart-feed/stores/feed/followers-feed-store";
import { useFollowingFeedStore } from "~/smart-feed/stores/feed/following-feed-store";
import SmartFeedEngine from "~/smart-feed/smart-feed-engine";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import useDynamicComponentBuilderStore from "%/stores/dynamic-component-builder-store";
import useDynamicComponentEditorStore from "%/dynamic-component-editor/stores/dynamic-component-editor";
// import { useMyExpertServicePackageFeedStore } from "@/smart-feed/stores/feed/my-expert-service-package-feed-store";

export const FEED_OPTIONS = {
  "HomeStories": {
    displayName: "Recent Stories",
    source: SmartFeedEngine.getFeedPiniaStore("RecentStoriesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    // Default pageEntities key when a row template DC is picked on
    // this feed. StoryCard mixins read pageEntities.story; the Feed
    // element wraps each row in a provide that maps the row entity's
    // id onto this key. Authors can override via FeedRowContextName
    // in the inspector when wiring an unusual feed/DC pair.
    rowContextName: "story",
    availableFilters: [
      { key: "hashtag_id", label: "Hashtag", compatibleUiTypes: ["pill_select", "single_select"], defaultUiType: "pill_select" },
    ],
  },
  "RecentStories": {
    displayName: "Explore",
    source: SmartFeedEngine.getFeedPiniaStore("RecentStoriesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
    availableFilters: [
      { key: "hashtag_id", label: "Hashtag", compatibleUiTypes: ["pill_select", "single_select"], defaultUiType: "pill_select" },
    ],
  },
  "StoriesByType": {
    displayName: "Stories by Type",
    source: SmartFeedEngine.getFeedPiniaStore("RecentStoriesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  "PopularStories": {
    displayName: "Popular Stories",
    source: SmartFeedEngine.getFeedPiniaStore("PopularStoriesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  "StoriesUserLoved": {
    displayName: "Stories User Loved",
    source: useLovedStoryFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  "StoriesUserVotedOn": {
    displayName: "Stories User Voted On",
    source: useVotedStoryFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  "RecentUserStories": {
    displayName: "Recent User Stories",
    source: SmartFeedEngine.getFeedPiniaStore("RecentUserStoriesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
    availableFilters: [
      { key: "hashtag_id", label: "Hashtag", compatibleUiTypes: ["pill_select", "single_select"], defaultUiType: "pill_select" },
    ],
  },
  "Videos": {
    displayName: "Videos",
    source: SmartFeedEngine.getFeedPiniaStore("SearchPublicationPostFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
    availableFilters: [
      { key: "tags", label: "Hashtag", compatibleUiTypes: ["pill_select", "multiple_select"], defaultUiType: "pill_select" },
      { key: "variant_type", label: "Content type", compatibleUiTypes: ["single_select", "pill_select"], defaultUiType: "single_select" },
      { key: "query", label: "Search", compatibleUiTypes: ["text_input"], defaultUiType: "text_input" },
    ],
  },
  "UserStoriesByHashtag": {
    displayName: "User Stories By Hashtag",
    source: SmartFeedEngine.getFeedPiniaStore("UserStoriesByHashtagFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  "StoriesUserCommentedOn": {
    displayName: "Stories User Commented On",
    source: useCommentedStoryFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  "TrendingHashtags": {
    displayName: "Trending Hashtags",
    source: SmartFeedEngine.getFeedPiniaStore("TrendingHashtagsFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "Hashtag",
    },
    entities: ["hashtag"],
  },
  "FollowedHashtags": {
    displayName: "Followed Hashtags",
    source: SmartFeedEngine.getFeedPiniaStore("OrgFollowedHashtagFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "Hashtag",
    },
    entities: ["hashtag"],
  },
  "ExclusiveStories": {
    displayName: "Exclusive Stories",
    source: useExclusiveStoryFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
    deprecated: true,
  },
  "PostsFromFeedGroup": {
    displayName: "Posts From Feed Group",
    source: useFeedGroupBlogPostFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  "Events": {
    displayName: "Events - All Events",
    source: useEventFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "EventCard",
      "large": "EventCardLarge",
    },
    entities: ["event"],
    rowContextName: "event",
    requiresFeature: "isEventsEnabled",
  },
  "UpcomingEvents": {
    displayName: "Events - Upcoming Events",
    source: SmartFeedEngine.getFeedPiniaStore("UpcomingEventsFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "EventCard",
      "large": "EventCardLarge",
    },
    entities: ["event"],
    rowContextName: "event",
    requiresFeature: "isEventsEnabled",
  },
  "FansBeingFollowed": {
    displayName: "Fans Being Followed",
    source: useFanFollowerBeingFollowedFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "FollowerCard",
      "large": "FollowerCardLarge",
    },
    entities: ["follower"],
    deprecated: true,
  },
  "FansFollowing": {
    displayName: "Fans Following",
    source: useFanFollowerFollowingFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "FollowerCard",
      "large": "FollowerCardLarge",
    },
    deprecated: true,
    entities: ["follower"],
  },
  "MyFollowers": {
    displayName: "My Followers",
    source: useFollowersFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "FollowerCard",
      "large": "FollowerCardLarge",
    },
    entities: ["following"],
  },
  "Following": {
    displayName: "Following",
    source: useFollowingFeedStore,
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "FollowerCard",
      "large": "FollowerCardLarge",
    },
    entities: ["following"],
  },
  "StoriesWithHashtag": {
    displayName: "Stories With Hashtags",
    source: SmartFeedEngine.getFeedPiniaStore("PublicationHashtagStoriesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
  },
  // "ExpertServices": {
  //   source: useMyExpertServicePackageFeedStore,
  //   layouts: ["grid", "list", "carousel"],
  //   variants: {
  //     "cardLarge": "ServicePackageCard",
  //   },
  //   entities: ["servicePackage"],
  // },
  "Collections": {
    displayName: "Collections",
    source: SmartFeedEngine.getFeedPiniaStore("CollectionsFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "large": "LargeCollectionCard",
      "small": "SmallCollectionCard",
    },
    entities: ["collection"],
    rowContextName: "collection",
  },
  "ProductLinkCollection": {
    displayName: "Product Link Collection",
    deprecated: true,
    deprecationWarning: "Deprecated. New feeds use FeedV2 with the Products source.",
    source: SmartFeedEngine.getFeedPiniaStore("ProductLinkCollectionFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "large": "AffiliateLinkCardLarge",
      "small": "AffiliateLinkCardSmall",
    },
    entities: ["affiliateLink"],
    rowContextName: "affiliateLink",
    availableFilters: [
      { key: "collection_id", label: "Collection", compatibleUiTypes: ["pill_select", "single_select"], defaultUiType: "pill_select" },
    ],
  },
  "ShowsFeedSource": {
    displayName: "Shows - All Shows",
    source: SmartFeedEngine.getFeedPiniaStore("ShowsFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "large": "ShowCardLarge",
      "small": "ShowCardSmall",
    },
    entities: ["show"],
  },
  "ShowSeasonsFeedSource": {
    displayName: "Shows - Seasons",
    source: SmartFeedEngine.getFeedPiniaStore("ShowSeasonsFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "large": "SeasonCardLarge",
      "small": "SeasonCardSmall",
    },
    entities: ["season"],
  },
  "ShowsRecentEpisodesFeedSource": {
    displayName: "Shows - Recent Episodes",
    source: SmartFeedEngine.getFeedPiniaStore("ShowsRecentEpisodesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "large": "EpisodeCardLarge",
      "small": "EpisodeCardSmall",
    },
    entities: ["episode"],
  },
  "ShowSeasonEpisodesFeedSource": {
    displayName: "Shows - Season Episodes",
    source: SmartFeedEngine.getFeedPiniaStore("ShowSeasonEpisodesFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "large": "EpisodeCardLarge",
      "small": "EpisodeCardSmall",
    },
    entities: ["episode"],
    requiresFeature: "isShowsEnabled",
  },
  "SearchPublicationPostFeedSource": {
    displayName: "Search Results",
    source: SmartFeedEngine.getFeedPiniaStore("SearchPublicationPostFeedSource"),
    layouts: ["grid", "list", "carousel"],
    variants: {
      "small": "StoryCard",
      "large": "LargeStoryCard",
    },
    entities: ["communityPost"],
    rowContextName: "story",
    deprecated: true,
    availableFilters: [
      { key: "query", label: "Search query", compatibleUiTypes: ["text_input"] },
      { key: "tags", label: "Tags", compatibleUiTypes: ["multiple_select", "pill_select"] },
      { key: "variant_type", label: "Content type", compatibleUiTypes: ["single_select", "pill_select"] },
    ],
  },
};

export const isFeedOptionAvailable = feedKey => {
  const feedConfig = FEED_OPTIONS[feedKey];
  if (!feedConfig) {
    return false;
  }
  if (!feedConfig.requiresFeature) {
    return true;
  }

  const configurationStore = useConfigurationStore();
  return Boolean(configurationStore[feedConfig.requiresFeature]);
};

export const getEnabledFeedOptions = () => {
  return Object.fromEntries(
    Object.entries(FEED_OPTIONS).filter(([feedKey]) => {
      return isFeedOptionAvailable(feedKey);
    }),
  );
};

// Standalone smart-feed elements (Collections, DigitalProducts, StoriesWithHashtag, …)
// don't expose a SmartFeedSelection picker — their FEED_OPTIONS entry is keyed by
// the element type itself. The Card Layout / Layout pickers fall through to this
// when the configured selection doesn't resolve.
export const COLLECTION_ROW_ELEMENT_FEED_OPTIONS = Object.freeze({
  SavedPosts: Object.freeze({ variants: Object.freeze({ small: "StoryCard", large: "LargeStoryCard" }) }),
  CollectionItems: Object.freeze({ variants: Object.freeze({ small: "StoryCard", large: "LargeStoryCard" }) }),
});

export const resolveFeedOptionConfigForInspectedElement = smartFeedSelection => {
  if (FEED_OPTIONS[smartFeedSelection]) {
    return FEED_OPTIONS[smartFeedSelection];
  }
  // Studio uses the editor store; legacy FanWeb builder uses the builder store.
  const inspectedType = useDynamicComponentEditorStore().currentlyInspectedElements?.[0]?.type
    ?? useDynamicComponentBuilderStore().currentlyInspectedElements?.[0]?.type;
  if (inspectedType && FEED_OPTIONS[inspectedType]) {
    return FEED_OPTIONS[inspectedType];
  }
  if (inspectedType && COLLECTION_ROW_ELEMENT_FEED_OPTIONS[inspectedType]) {
    return COLLECTION_ROW_ELEMENT_FEED_OPTIONS[inspectedType];
  }
  return null;
};
